<template>
  <div class="trans-slides">
    <div class="steady-image" :class="{'trans-show': trans2Show}"><img :src="trans2Src"></div>
    <div class="trans-image" :class="{'trans-show': trans1Show, trans: doTrans}"><img :src="trans1Src"></div>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
// slides is an array of url which we will transition between
export default {
  props: {
    slides: {
      type: Array,
      default: function () { return [] }
    },
    delay: {
      type: Number,
      default: 600
    }
  },
  data: function () {
    return {
      current: 0,
      trans1Src: null,
      trans2Src: null,
      trans1Show: false,
      trans2Show: false,
      doTrans: false,
      mwidth:1024
    }
  },
  mounted: function () {
    this.mwidth = window.innerWidth
    this.$el.addEventListener('mouseover', () => {
      this.startChanging()
    })
    this.$el.addEventListener('mouseout', () => {
      this.stopChanging()
    })
  },
  methods: {
    startChanging: async function () {
      if(!this.running) {
        this.running = true
        await this.$k.waitfor(100)
        if(this.running){
          this.changeImage()
        }
        
      }
    },
    stopChanging: async function () {
      this.running = false
      this.trans1Show = false
      this.trans2Show = false
    },
    changeImage: async function () {
      if(!this.running) {
        this.stopChanging()
        return
      }
      const max = this.slides.length
      if(max == 0) {
        this.callAgain()
        return;
      }
      if(this.current >= max) {
        this.current = 0
      }
      let url = this.$k.getImageCrop320(this.slides[this.current].url)
      if(this.mwidth > 1400) {
        url = this.$k.getImageCrop500(this.slides[this.current].url)
      }
      this.trans1Src = url
      await this.$k.loadImage(url)
      if(!this.running) {
        this.stopChanging()
        return
      }
      this.doTrans = true
      this.trans1Show = true
      this.current++
      await this.$k.waitfor(400)
      if(!this.running) {
        this.stopChanging()
        return
      }
      this.trans2Src = url
      this.trans2Show = true
      this.doTrans = false
      await this.$k.waitfor(200)
      
      if(!this.running) {
        this.stopChanging()
        return
      }
      this.trans1Show = false
      await this.$k.waitfor(this.delay)  
      if(!this.running) {
        this.stopChanging()
        return
      }
      this.changeImage()

    },
    callAgain: function () {
      setTimeout(() => {
        if(!this.running) return
        this.changeImage()
      }, this.delay)
    }
  }
}
</script>

<style scoped>
.trans-image{
  opacity:0;
  pointer-events: none;
  position:absolute;
  top:0;
  left:0;
  z-index:5;
  width:100%;
  height:100%;
}

.trans-image.trans{
  transition:opacity 0.3s ease;
}

.steady-image{
  opacity:0;
  pointer-events: none;
  position:absolute;
  top:0;
  left:0;
  z-index:4;
  width:100%;
  height:100%;
}

.trans-image img, .steady-image img{
  display:block;
  width:100%;
  height:100%;
  box-sizing: border-box;
}

.trans-image.trans-show, .steady-image.trans-show{
  opacity:1;
}

.trans-slides{
  position:absolute;
  z-index:30;
  width:100%;
  padding-bottom:100%;
  top:0;
  left:0;
  box-sizing: border-box;
}
</style>
